
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import deDE from "../../lib/presets/resources/de-DE";
import { container } from "../../lib/container";
import { ContainerTypes } from "../../lib/core/types/ContainerTypes";
import { RoutingStorage } from "../../lib/core/storage/RoutingStorage";
import { SpeedProfile } from "../../lib/interfaces/state-events/RoutingRequest";
import { getConfig } from "../../lib/ConfigLoader";

const storage = container.get<RoutingStorage>(ContainerTypes.RoutingStorage);

@Component
export default class SpeedProfileBtn extends Vue {
  @Prop({ required: true })
  value!: SpeedProfile;
  src!: string;
  text!: string;

  @Inject() active: SpeedProfile = storage.speedProfile;

  activate() {
    return { active: this.value === this.active };
  }

  onClick(event: Event) {
    event.preventDefault();
    storage.speedProfile = this.value;
  }

  created() {
    const config = getConfig();
    this.src = config.routingView.speedProfile[this.value];
    this.text = deDE.routingView.speedProfile[this.value];
  }

  mounted() {}
}
